import { I18n } from '@/i18n/I18n';
import { Operation } from '@/backend/models/operation';
import { InputParameterSelect } from '@/frontend/components/parameters/InputParameterSelect';
import { OutputParameterSelect } from '@/frontend/components/parameters/OutputParameterSelect';
import { ParameterValue } from '@/frontend/components/parameters/ParameterItem';
import { Form } from 'react-bootstrap';

interface FileInputSectionProps {
  runView?: boolean;
  operation: Operation;
  parameter: any;
}

export function FileInputSection({
  runView,
  operation,
  parameter
}: FileInputSectionProps) {
  if (runView) return null;

  return (
    <div className="mb-3">
      <p className="form-label">{I18n.get('graphDataFile')}</p>
      { parameter && <div className="d-flex gap-2 mb-2">
          <Form.Label className="col-form-label col-form-label-sm">{I18n.get('assignValueFrom')}:</Form.Label>
          <InputParameterSelect operation={operation} parameter={parameter} />
        </div> }
      { parameter && <ParameterValue parameter={parameter} /> }
      <div className="form-text" aria-label={I18n.get('noFileUploaded')}>
        {I18n.get('graphFileHelp')}
      </div>
    </div>
  );
}

export function GraphCaptureOutputSection({
  runView,
  operation,
  parameter
}: FileInputSectionProps) {
  if (runView) return null;

  return (
    <div className="mb-3">
      <p className="form-label">{I18n.get('graphCaptureOutput')}</p>
      { parameter && <div className="d-flex gap-2 mb-2">
          <Form.Label className="col-form-label col-form-label-sm">{I18n.get('assignGraphImageTo')}</Form.Label>
          <OutputParameterSelect operation={operation} parameter={parameter} />
        </div> }
    </div>
  );
}

